import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { coursesApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import Curriculum from "./Curriculum";
import classes from "./CurriculumPage.module.css"

const CurriculumPage = () => {
    const texts = useSelector(state => state.translate.texts);
    const [data, setData] = useState()
    const { guid } = useParams()
    const dispatch = useDispatch();
    const componentMounted = useRef(true);

    useEffect(() => {

        coursesApi.coursesFilterIdPost(guid, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.coursesFilterError, error: error, statusCode: response?.statusCode, message: "coursesFilterRangePost " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    if (resdata.additionalData) {
                        const parse = JSON.parse(resdata.additionalData)
                        resdata.additionalData = parse;
                        resdata.pageBackgroundImage = `${resdata.baseUrl}/${parse?.PageBackgroundImage}`
                    }
                    setData({ ...resdata })
                }
            }
        })
    }, [guid])


    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    return <div className={classes.CurriculumPage}>
        {data && <Curriculum data={data} ></Curriculum>}
    </div>
}

export default CurriculumPage;